import type { ReactNode } from 'react'
import { DashboardLayout, type DashboardLayoutProps } from '@/components/layout/DashboardLayout'
import type { WizardStepKey } from '@/types'
import { WizardProgressRail } from './WizardProgressRail'

type WizardLayoutProps = Omit<DashboardLayoutProps, 'children' | 'navigation'> & {
  children: ReactNode
  currentStep: WizardStepKey
  formationId?: string
  resumeStep?: WizardStepKey
  editable?: boolean
}

/**
 * Keeps wizard navigation in the desktop sidebar while preserving the compact
 * progress summary at the top of the form on smaller screens.
 */
export function WizardLayout({
  children,
  currentStep,
  formationId,
  resumeStep,
  editable,
  ...layoutProps
}: WizardLayoutProps) {
  const progressProps = { currentStep, formationId, resumeStep, editable }

  return (
    <DashboardLayout
      {...layoutProps}
      navigation={<WizardProgressRail {...progressProps} variant="desktop" />}
    >
      <div className="mb-8 lg:hidden">
        <WizardProgressRail {...progressProps} variant="mobile" />
      </div>
      {children}
    </DashboardLayout>
  )
}
